import {
  PARAMETER_SCOPE,
  PARAMETER_CLIENT_ID,
  PARAMETER_REDIRECT_URI,
} from "src/Utilities/constants";
import useLanguageMiddleware from "./useLanguageMiddleware";

function useCfgURLParams() {
  let queryParams = new URLSearchParams(window.location.search);
  const clientId = queryParams.get(PARAMETER_CLIENT_ID);
  const scope = queryParams.get(PARAMETER_SCOPE);
  const redirect = queryParams.get(PARAMETER_REDIRECT_URI);
  // TODO: parse nonce with env var const
  const nonce = queryParams.get("nonce");
  // TODO: parse state with env var const
  const state = queryParams.get("state");
  const middleware = useLanguageMiddleware;
  return {
    clientId: process.env.REACT_APP_CONFIG_CLIENT_ID,
    middleware: [middleware],
    // clientId:
    //   clientId === null ? process.env.REACT_APP_CONFIG_CLIENT_ID : clientId,
    // middleware: [middleware],
    redirect: redirect === null ? "dashboard" : redirect,
    scope: scope === null ? process.env.REACT_APP_CONFIG_SCOPE : scope,
    // TODO: set nonce + env default
    nonce,
    // TODO: set state + env default
    state,
  };
}
export default useCfgURLParams;
